(() => {
  'use strict';

  if (window.__kosvyreImmersiveLoaded) return;
  window.__kosvyreImmersiveLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(any-pointer: fine)');
  const revealItems = Array.from(document.querySelectorAll('[data-tt-reveal]'));
  const tiltItems = Array.from(
    document.querySelectorAll('[data-tt-tilt], .tt-format-card, .tt-transmission__card, .tt-collection-hero__media')
  );
  const stage = document.querySelector('[data-tt-stage]');

  let motionController;
  let revealObserver;
  let frame = 0;
  let pointerX = 0;
  let pointerY = 0;

  const revealEverything = () => {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  };

  const clearMotionState = (reveal = false) => {
    motionController?.abort();
    motionController = undefined;
    revealObserver?.disconnect();
    revealObserver = undefined;

    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;

    document.documentElement.classList.remove('tt-motion-ready');

    if (stage) {
      [
        '--tti-pointer-x',
        '--tti-pointer-y',
        '--tti-hero-rx',
        '--tti-hero-ry',
        '--tti-hero-tx',
        '--tti-hero-ty',
        '--tti-shine-x',
      ].forEach((property) => stage.style.removeProperty(property));
    }

    tiltItems.forEach((card) => {
      card.style.removeProperty('--tti-card-x');
      card.style.removeProperty('--tti-card-y');
    });

    if (reveal) revealEverything();
  };

  const enableMotion = () => {
    clearMotionState(false);

    if (reducedMotion.matches) {
      clearMotionState(true);
      return;
    }

    document.documentElement.classList.add('tt-motion-ready');
    motionController = new AbortController();
    const { signal } = motionController;

    if ('IntersectionObserver' in window && revealItems.length) {
      revealObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-visible');
            revealObserver?.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      revealItems.forEach((item) => revealObserver.observe(item));
    } else {
      revealEverything();
    }

    if (!finePointer.matches) return;

    const paintStage = () => {
      frame = 0;
      if (!stage) return;
      stage.style.setProperty('--tti-pointer-x', pointerX.toFixed(3));
      stage.style.setProperty('--tti-pointer-y', pointerY.toFixed(3));
      stage.style.setProperty('--tti-hero-rx', `${(-pointerY * 1.4).toFixed(2)}deg`);
      stage.style.setProperty('--tti-hero-ry', `${(pointerX * 1.7).toFixed(2)}deg`);
      stage.style.setProperty('--tti-hero-tx', `${(pointerX * 5).toFixed(2)}px`);
      stage.style.setProperty('--tti-hero-ty', `${(pointerY * 5).toFixed(2)}px`);
      stage.style.setProperty('--tti-shine-x', `${(pointerX * 3).toFixed(2)}%`);
    };

    if (stage) {
      stage.addEventListener(
        'pointermove',
        (event) => {
          const rect = stage.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          pointerX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
          pointerY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
          if (!frame) frame = window.requestAnimationFrame(paintStage);
        },
        { passive: true, signal }
      );

      stage.addEventListener(
        'pointerleave',
        () => {
          pointerX = 0;
          pointerY = 0;
          if (!frame) frame = window.requestAnimationFrame(paintStage);
        },
        { passive: true, signal }
      );
    }

    tiltItems.forEach((card) => {
      card.addEventListener(
        'pointermove',
        (event) => {
          const rect = card.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
          card.style.setProperty('--tti-card-x', `${(x * 2.2).toFixed(2)}deg`);
          card.style.setProperty('--tti-card-y', `${(y * -2.2).toFixed(2)}deg`);
        },
        { passive: true, signal }
      );

      card.addEventListener(
        'pointerleave',
        () => {
          card.style.removeProperty('--tti-card-x');
          card.style.removeProperty('--tti-card-y');
        },
        { passive: true, signal }
      );
    });
  };

  enableMotion();

  if ('addEventListener' in reducedMotion) {
    reducedMotion.addEventListener('change', enableMotion);
  }
})();
